import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { appendTestableElementAttributes } from '@dreryk/react-components';

import { PatientAutosuggestItemDetails } from './PatientAutosuggestItemDetails';
import { PatientAutosuggestItemName } from './PatientAutosuggestItemName';

type PatientAutosuggestItemProps = {
   readonly patient: PatientSimple;
};

export const PatientAutosuggestItem = (props: PatientAutosuggestItemProps): JSX.Element => {
   return (
      <div {...appendTestableElementAttributes(String(props.patient.id))}>
         <PatientAutosuggestItemName patient={props.patient} />
         <PatientAutosuggestItemDetails patient={props.patient} />
      </div>
   );
};
